module.exports = __webpack_public_path__ + "img/crm2.ba647e1b.png";